import React, { useEffect, useState } from "react";
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDocs,
  query,
  Timestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "../firebase";
import { useCuerpo } from "../context/CuerpoContext";

const VACIO = { nombre: "", codigo: "", compania_id: "", activo: true, orden: 1 };

export default function GestionUnidades() {
  const { cuerpo, cuerpoId } = useCuerpo();
  const [unidades, setUnidades] = useState([]);
  const [companias, setCompanias] = useState([]);
  const [form, setForm] = useState(VACIO);
  const [editandoId, setEditandoId] = useState(null);
  const [cargando, setCargando] = useState(true);

  async function cargar() {
    if (!cuerpoId) return;
    setCargando(true);
    try {
      const [us, cs] = await Promise.all([
        getDocs(query(collection(db, "unidades"), where("cuerpo_id", "==", cuerpoId))),
        getDocs(query(collection(db, "companias"), where("cuerpo_id", "==", cuerpoId))),
      ]);
      const ua = us.docs.map(d => ({ id: d.id, ...d.data() })).sort((a,b)=>Number(a.orden||9999)-Number(b.orden||9999));
      const ca = cs.docs.map(d => ({ id: d.id, ...d.data() })).sort((a,b)=>Number(a.orden||9999)-Number(b.orden||9999));
      setUnidades(ua); setCompanias(ca);
    } finally { setCargando(false); }
  }

  useEffect(() => { cargar().catch(console.error); }, [cuerpoId]);

  function limpiar() { setForm(VACIO); setEditandoId(null); }

  function editar(u) {
    setEditandoId(u.id);
    setForm({
      nombre: u.nombre || u.codigo || u.unidad || "",
      codigo: u.codigo || u.nombre || u.unidad || "",
      compania_id: u.compania_id || "",
      activo: (u.activo ?? u.operativa ?? true) !== false,
      orden: Number(u.orden || 1),
    });
  }

  async function guardar() {
    if (!cuerpoId) return;
    const nombre = String(form.nombre || form.codigo).trim().toUpperCase();
    const codigo = String(form.codigo || form.nombre).trim().toUpperCase();
    if (!nombre) return alert("Ingresa el nombre/código de la unidad.");
    const cia = companias.find(c => c.id === form.compania_id);
    const payload = {
      nombre, codigo,
      cuerpo_id: cuerpoId,
      compania_id: cia?.id || null,
      compania: cia?.nombre || "Comandancia",
      activo: !!form.activo,
      orden: Number(form.orden || 1),
      updatedAt: Timestamp.now(),
    };
    try {
      if (editandoId) await updateDoc(doc(db, "unidades", editandoId), payload);
      else await addDoc(collection(db, "unidades"), { ...payload, createdAt: Timestamp.now() });
      limpiar(); await cargar();
    } catch (e) { console.error(e); alert("No se pudo guardar la unidad: " + e.message); }
  }

  async function eliminar(u) {
    if (!window.confirm(`¿Eliminar la unidad ${u.nombre || u.codigo || u.id}?`)) return;
    try { await deleteDoc(doc(db, "unidades", u.id)); await cargar(); }
    catch (e) { console.error(e); alert("No se pudo eliminar la unidad."); }
  }

  return (
    <div style={{ maxWidth: 1000 }}>
      <h2>Unidades</h2>
      <p>Unidades de <strong>{cuerpo?.nombre || cuerpoId}</strong>. Cada unidad queda aislada por Cuerpo.</p>
      <div style={{ display: "grid", gap: 8, maxWidth: 650, padding: 16, border: "1px solid #ddd", borderRadius: 10, marginBottom: 22 }}>
        <input value={form.nombre} onChange={e=>setForm({...form,nombre:e.target.value})} placeholder="Código / nombre (ej. B-1)" />
        <select value={form.compania_id} onChange={e=>setForm({...form,compania_id:e.target.value})}>
          <option value="">Comandancia / sin compañía</option>
          {companias.map(c=><option key={c.id} value={c.id}>{c.nombre}</option>)}
        </select>
        <input type="number" min="1" value={form.orden} onChange={e=>setForm({...form,orden:e.target.value})} placeholder="Orden" />
        <label><input type="checkbox" checked={form.activo} onChange={e=>setForm({...form,activo:e.target.checked})}/> Unidad activa</label>
        <div><button onClick={guardar}>{editandoId ? "Guardar cambios" : "Crear unidad"}</button>{" "}{editandoId && <button onClick={limpiar}>Cancelar</button>}</div>
      </div>
      {cargando ? <p>Cargando...</p> : (
        <table style={{ borderCollapse:"collapse", width:"100%" }}>
          <thead><tr><th>Orden</th><th>Unidad</th><th>Asignación</th><th>Estado</th><th></th></tr></thead>
          <tbody>{unidades.map(u=><tr key={u.id}><td>{u.orden ?? "—"}</td><td>{u.nombre || u.codigo || u.unidad || u.id}</td><td>{u.compania || "Comandancia"}</td><td>{(u.activo ?? u.operativa ?? true)!==false ? "Activa":"Inactiva"}</td><td><button onClick={()=>editar(u)}>Editar</button>{" "}<button onClick={()=>eliminar(u)}>Eliminar</button></td></tr>)}</tbody>
        </table>
      )}
    </div>
  );
}
